<h4 mat-dialog-title>Delete</h4>
<div mat-dialog-content>
  <p>{{ data.message }}</p>
</div>
<div mat-dialog-actions>
  <button mat-dialog-close mat-flat-button color="primary">
    {{ 'BUTTON.BTN_CANCEL' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="onConfirm()">{{ 'BUTTON.BTN_CONFIRM' | translate }}</button>
</div>